export const ActionTypes = {
  LOADING: "GOOGLE_LOGIN_LOADING",
  ERROR: "GOOGLE_LOGIN_ERROR",
  SUCCESS: "GOOGLE_LOGIN_SUCCESS",
};
